// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2vn3z","productName":"Table_productName__AJ9Dr"};